import { toHaveStyle } from '@testing-library/jest-dom/dist/matchers';
import React, { Component } from 'react';
import {RegWrapper} from './RegWrapper.js';
import axios from 'axios';
import validator from 'validator';
import {Loader} from './Loader.js';

export class PassCreator extends Component {

    state = {
        pass1: '',
        pass2: '',
        success: null,
        showErrorMsg: false,
        errorMsg: null,
        isSending: false,
        inputErrorMessage: null
    }
    
    constructor(props) {
        super(props)
        this.props = props 
    }

    updatePass1 = (e) => {
        const updatedInputValue = e.target.value;
        
        this.setState((prevState) => {
             return  {
                    ...prevState,
                    pass1: updatedInputValue,
                    inputErrorMessage: null
                };
        }, () =>  {
            
        })
    }

    updatePass2 = (e) => {
        const updatedInputValue = e.target.value;
        
        this.setState((prevState) => {
             return  {
                    ...prevState,
                    pass2: updatedInputValue,
                    inputErrorMessage: null
                };
        }, () =>  {
            
        })
    }

    msgTimer = 3000

    doShowErrorMsg(msg) {
        this.setState((prevState) => {
            return {
                ...prevState,
                isSending: false,
                errorMsg: msg,
                showErrorMsg: true
            };
        })
        
        setTimeout(() => { 
            this.setState((prevState) => {
                return {
                    ...prevState,
                    errorMsg: null,
                    showErrorMsg: false
                };
            })
        }, this.msgTimer)
    }

    sendRequest = (e) => {
        e.preventDefault();

        // Проверка совпадения паролей
        if (this.state.pass1 !== this.state.pass2) {
            this.setState((prevState) => {
                return {
                    ...prevState,
                    inputErrorMessage: 'Пароли не совпадают'
                };
            })
            return;
        }

        // Валидация пароля
        if (!validator.isStrongPassword(this.state.pass1, {
            minLength: 8, minNumbers: 0, minSymbols: 0, minLowercase: 0, minUppercase: 0
        })) { 
            this.setState((prevState) => {
                return {
                    ...prevState,
                    inputErrorMessage: 'Пароль должен содержать не менее 8 символов'
                };
            })
            return;
        }

        // Проверка наличия токена
        if (!this.props.match.params.token) {
            this.doShowErrorMsg('Токен сброса пароля отсутствует');
            return;
        }
        
        this.setState({isSending: true});

        axios
        .post('https://api.clickanti.ru/api/users/reset-password/', {
            'token': this.props.match.params.token,
            'new_password': this.state.pass1
        })
        .then(res => {
            if (res.status === 200 && res.data.message) {
                this.setState({
                    success: true,
                    isSending: false
                });
            } else {
                this.setState({
                    success: false,
                    isSending: false
                });
                this.doShowErrorMsg('Неожиданный ответ сервера');
            }
        })
        .catch(err => {
            console.log('Password reset error:', err);
            
            let errorMessage = 'Ошибка сброса пароля';
            
            // Обработка ошибок от бекенда
            if (err.response && err.response.data) {
                if (err.response.data.error) {
                    errorMessage = err.response.data.error;
                } else if (err.response.status === 400) {
                    errorMessage = 'Неверный или истекший токен. Запросите сброс пароля заново.';
                } else if (err.response.status === 404) {
                    errorMessage = 'Токен не найден';
                }
            } else if (err.request) {
                errorMessage = 'Ошибка соединения с сервером';
            }

            this.setState({
                success: false,
                isSending: false
            });
            
            this.doShowErrorMsg(errorMessage);
        })
    }

    redirect = (e) => {
        window.location.href = '/auth';
    }

    componentDidUpdate(prevProps, prevState) {
        // Редирект после успешной смены пароля
        if (this.state.success === true && prevState.success !== true) {
            setTimeout(() => {
                window.location.href = '/auth';
            }, 2000); // Даем пользователю 2 секунды увидеть сообщение об успехе
        }
    }

    render() {
        return (
            
        <RegWrapper errorMsg={this.state.errorMsg} showErrorMsg={this.state.showErrorMsg}>
            <Loader loader={this.state.isSending} />
            
            {/* Форма смены пароля */}
            {this.state.success === null && (
                <div>
                    <div><h1>Сменить пароль</h1></div>
                    <div className="uk-margin">
                        <input 
                            className={
                                this.state.inputErrorMessage == null ? 
                                "uk-input uk-form-width-large uk-form-large uk-background-muted"
                                :
                                "uk-input uk-form-width-large uk-form-large uk-background-muted error_input"
                            }
                            type="password" 
                            placeholder="Новый пароль*" 
                            value={this.state.pass1}
                            onChange={e => this.updatePass1(e)}
                        />
                    </div>
                    <div className="uk-margin">
                        <input 
                            className={
                                this.state.inputErrorMessage == null ? 
                                "uk-input uk-form-width-large uk-form-large uk-background-muted"
                                :
                                "uk-input uk-form-width-large uk-form-large uk-background-muted error_input"
                            }
                            type="password" 
                            placeholder="Новый пароль повтор*" 
                            value={this.state.pass2}
                            onChange={e => this.updatePass2(e)}
                        />
                        <div className='input_error'>{this.state.inputErrorMessage}</div> 
                    </div>
                    
                    <div className="main-left-bottom">
                        <button 
                            onClick={e => this.sendRequest(e)} 
                            className="btn1"
                            disabled={this.state.isSending}
                        >
                            Сохранить
                        </button>
                    </div>
                </div>
            )}

            {/* Успешная смена пароля */}
            {this.state.success === true && (
                <div>
                    <h1>Пароль успешно изменен!</h1>
                    <p style={{marginTop: '20px', fontSize: '16px'}}>
                        Сейчас вы будете перенаправлены на страницу входа...
                    </p>
                    <div style={{marginTop: '30px'}}>
                        <a href='/auth' className="btn1">Войти</a>
                    </div>
                </div>
            )}

            {/* Ошибка смены пароля */}
            {this.state.success === false && (
                <div>
                    <h1>Не получилось изменить пароль</h1>
                    <p style={{marginTop: '20px', fontSize: '16px'}}>
                        Возможно, токен истек или неверен. Попробуйте запросить сброс пароля заново.
                    </p>
                    <div style={{marginTop: '30px'}}>
                        <a href='/passreset' className="btn1" style={{marginRight: '10px'}}>
                            Сбросить пароль
                        </a>
                        <a href='/auth' className="btn1">
                            Вход
                        </a>
                    </div>
                </div>
            )}

        </RegWrapper>  

        )
    }

}